if (!customElements.get('free-items-drawer')) {
    customElements.define(
        'free-items-drawer',
        class FreeItemsDrawer extends HTMLElement {
            constructor() {
                super();
            }
    
            open() {
                setTimeout(() => {
                    this.classList.add('active');
                });

                this.addEventListener('transitionend', () => {
                    this.intentionallyTrapFocus();
                }, { once: true });
            }

            close() {
                this.classList.remove("active");
                removeTrapFocus(this);
            }

            intentionallyTrapFocus(element = null) {
                trapFocus(this, element || this.querySelector(".free-items-drawer__back"));
            }
        }
    );
}

if (!customElements.get('free-items-category')) {
    customElements.define(
        'free-items-category',
        class FreeItemsCategory extends HTMLElement {
            constructor() {
                super();
                
                this.targetDrawer = this.getAttribute("data-target");

                this.cartDrawer = this.closest('cart-drawer');
                this.cartDrawerItems = this.cartDrawer.querySelector("cart-drawer-items");

                this.freeItemsCategoryDrawer = this.cartDrawer.querySelector(`[data-drawer='${this.targetDrawer}']`);
                this.freeItemsCategoryTrigger = this.querySelector(".free-item-category-picker");

                this.freeItemsCategoryTrigger.addEventListener('click', () => {
                    this.open();
                });
            }
    
            open() {
                setTimeout(() => {
                    this.freeItemsCategoryDrawer.classList.add("animate", "active");
                });

                this.freeItemsCategoryDrawer.addEventListener('transitionend', () => {
                    const containerToTrapFocusOn = this.freeItemsCategoryDrawer;
                    const focusElement = this.freeItemsCategoryDrawer.querySelector('.free-items-drawer__back');

                    trapFocus(containerToTrapFocusOn, focusElement);
                    }, { once: true }
                );
            }

            close() {
                this.freeItemsCategoryDrawer.classList.remove("active");
                removeTrapFocus(this.freeItemsCategoryDrawer);
            }

            addFreeItem(productId) {
                const data = {
                    quantity: 1,
                    id: productId,
                    properties: {
                        '_mpb': 'free'
                    },
                    sections:["cart-drawer","cart-icon-bubble"],
                    sections_url: "/"
                }

                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                })
                .then((response) => response.json())
                .then(response => {
                    if (response.status) {
                        console.log(response.status);
                    }

                    this.cartDrawer.renderContents(response);
                })
                .catch((error) => {
                    console.error('Error:', error);
                })
                .finally(() => {
                    this.close();
                    const cartDrawerItems = document.querySelector("cart-drawer-items");
                    cartDrawerItems.setAttribute("data-free-item-in-cart", "added");
                    
                    const freeItemsDrawer = this.closest("free-items-drawer");
                    freeItemsDrawer.close();

                    this.cartDrawer.intentionallyTrapFocus();
                });
            }

            changeFreeItem(existingFreeItemIndex, newFreeItemId) {

                let updates = {};
                updates[existingFreeItemIndex] = 0;
                
                fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ updates })
                })
                .then(() => {
                    if (newFreeItemId) {
                        this.addFreeItem(newFreeItemId);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                })
                .finally(() => {
                    this.cartDrawer.intentionallyTrapFocus();
                });
            }

            disableLoading(event) {
                event.target.setAttribute('aria-disabled', true);
                event.target.classList.add('loading');
                event.target.querySelector('.loading__spinner').classList.remove('hidden');
            }
        }
    );
}